"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var ScanFingerprint = function (_a) {
    var fill = _a.fill, props = __rest(_a, ["fill"]);
    return (React.createElement("svg", __assign({ fill: "none", viewBox: "0 0 24 24", width: "1em", height: "1em" }, props),
        React.createElement("path", { d: "M9.779 2.248A10.03 10.03 0 0 1 12 2c5.523 0 10 4.477 10 10 0 1.59-.263 3.411-.516 4.804a46.216 46.216 0 0 1-.501 2.387l-.01.037-.002.01v.004L20 19l-.97-.242v-.002l.002-.007.008-.032.03-.126a44.212 44.212 0 0 0 .446-2.145C19.763 15.09 20 13.41 20 12a8 8 0 0 0-9.779-7.802l-.442-1.95zM2 12a9.991 9.991 0 0 1 4.444-8.315l1.112 1.662A7.991 7.991 0 0 0 4 12c0 1.61-.268 2.954-.538 3.9-.136.473-.272.85-.377 1.112a7.746 7.746 0 0 1-.17.395l-.013.026-.005.009-.001.003-.001.001L2 17l-.895-.447v.002l.003-.008.024-.05a5.73 5.73 0 0 0 .096-.228c.082-.206.196-.517.31-.919.23-.804.462-1.96.462-3.35z", fill: fill || 'currentColor' }),
        React.createElement("path", { d: "M6 12a6 6 0 0 1 9.6-4.8l-1.2 1.6A4 4 0 0 0 8 12c0 2.628-.525 4.98-1.044 6.67-.26.846-.522 1.531-.72 2.01a15.977 15.977 0 0 1-.312.707l-.02.041-.006.013-.002.004-.001.001L5 21l-.895-.447.003-.005.013-.027.056-.12c.05-.108.123-.272.211-.486.178-.429.417-1.056.656-1.834C5.524 16.519 6 14.37 6 12zm10 0c0-.275-.028-.543-.08-.801l1.96-.398c.079.388.12.79.12 1.199 0 2.628-.525 4.98-1.044 6.67-.26.846-.522 1.531-.72 2.01a15.96 15.96 0 0 1-.312.707l-.02.041-.006.013-.002.004-.001.001L15 21l-.895-.447.003-.005.013-.027.056-.12c.05-.108.123-.272.212-.486.177-.429.416-1.056.655-1.834.48-1.562.956-3.71.956-6.081z", fill: fill || 'currentColor' }),
        React.createElement("path", { d: "M13 11v1a19.67 19.67 0 0 1-.274 3.162l-.161.987-1.974-.324.162-.987c.151-.924.247-1.886.247-2.838v-1h2zm-.992 7.362-.311.95a28.334 28.334 0 0 1-.715 1.935c-.02.05-.037.088-.049.114l-.013.032-.004.009-.002.003L10 21l.914.405-.406.915-1.828-.812.406-.914.002-.005.01-.022.04-.094a26.282 26.282 0 0 0 .658-1.784l.312-.951 1.9.624z", fill: fill || 'currentColor' })));
};
exports.default = ScanFingerprint;
